<template>
  <section v-if="view.visible" class="vote-recovery activity-record-panel" aria-label="原投票结果" :aria-busy="view.loading">
    <h4>原投票结果</h4>
    <p v-if="view.result?.requestId || view.pending">请求编号：{{view.result?.requestId || view.pending}}</p>
    <p v-if="view.loading" role="status">正在核对原投票结果…</p>
    <ErrorNotice v-if="view.error" :message="view.error"></ErrorNotice>
    <template v-if="view.result"><p>{{view.result.stageTitle}} · {{view.result.candidateName}} · {{view.result.voteCount}} 票</p><p>{{time(view.result.createdAt)}}（北京时间） · 已确认</p></template>
    <ActivityAction variant="secondary" :disabled="view.loading || !active" @click="refresh">重新核对原结果</ActivityAction>
    <ActivityAction variant="secondary" @click="emit('records')">查看本人投票记录</ActivityAction>
  </section>
</template>
<script setup>
import ErrorNotice from '../feedback/ErrorNotice.vue'
import { onBeforeUnmount, ref, watch } from 'vue'
import { createVoteReceiptRecovery } from '../../services/activities/voteStage.mjs'
import { useWebActivity, gameplayApi, activityStorage } from '../../services/activities/webAdapter.js'
import ActivityAction from './ActivityAction.vue'
const props=defineProps({activityId:{type:[Number,String],required:true},active:{type:Boolean,default:true},receipt:{type:Object,default:null}})
const emit=defineEmits(['records'])
const {getAuth,getToken}=useWebActivity()
const view=ref({visible:false,loading:false})
const recovery=createVoteReceiptRecovery({recover:gameplayApi.voteResult,identity:()=>getAuth()?.memberId||'',token:getToken,storage:activityStorage,changed:value=>{view.value=value}})
const time=value=>new Date(value*1000).toLocaleString('zh-CN',{timeZone:'Asia/Shanghai',hour12:false})
function refresh(){if(props.active)return recovery.open(props.activityId,props.receipt);recovery.pause()}
watch(()=>[props.activityId,props.active,props.receipt,getToken(),getAuth()?.memberId],()=>void refresh(),{immediate:true})
function syncIdentity(event){if(!event.key||event.key.startsWith('web:kg_vote:v1:'))void refresh()}
window.addEventListener('storage',syncIdentity)
onBeforeUnmount(()=>{recovery.pause();window.removeEventListener('storage',syncIdentity)})
</script>
<style scoped src="./activity-records.css"></style>
